import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import { HANDBOOK_TEMPLATE_LVL, handBookActions } from "../model/slice";
import { useTypedSelector } from "app/store/typedUseSelector";

export const useCheckAll = ({
  lvl,
  displayItems,
}: {
  lvl: HANDBOOK_TEMPLATE_LVL;
  displayItems: Array<{ id: number }>;
}) => {
  const dispatch = useDispatch();
  const editings = useTypedSelector((state) => state.handBookReducer.templateEditings);

  const allChecked = useMemo(() => {
    if (!displayItems || displayItems.length === 0) return false;
    return displayItems.every((item) => editings[lvl].checked[item.id]);
  }, [displayItems, editings[lvl].checked]);

  const handleToggleAllChecked = useCallback(() => {
    if (!displayItems || displayItems.length === 0) return;

    const newCheckedState = !allChecked;

    displayItems.forEach((item) => {
      if (Boolean(editings[lvl].checked[item.id]) !== newCheckedState) {
        dispatch(
          handBookActions.localCheckTemplateItem({
            id: item.id,
            isChecked: newCheckedState,
            lvl,
          })
        );
      }
    });
  }, [displayItems, allChecked, editings[lvl].checked, dispatch]);

  return {
    allChecked,
    handleToggleAllChecked,
  };
};
